import { ConfigInfo } from "../models/roundRobin.model";
import axiosSetup from "../utils/axiosSetup";

export const getRoundRobinDataApi = async () => {
  const response = await axiosSetup.get("/roundRobin/getRoundRobinData");
  return response?.data;
};

export const getReportOfAllNumbersBasedOnDateApi = async (date: string) => {
  const response = await axiosSetup.post(
    "/roundRobin/getReportOfAllNumbersBasedOnDate",
    {
      date,
    }
  );
  return response?.data;
};
export const getReportBasedOnDateApi = async (date: string) => {
  const response = await axiosSetup.post(
    "/roundRobin/getWhatsAppAutomationReportBasedOnDate",
    {
      date,
    }
  );
  return response?.data;
};

export const getAllTimeWhatsAppAutomationReportApi = async () => {
  const response = await axiosSetup.get(
    "/roundRobin/getWhatsAppAutomationReport"
  );
  return response?.data;
};

export const getCronJobStatusApi = async () => {
  const response = await axiosSetup.get("/roundRobin/getCronJobStatus");
  return response?.data?.data?.running;
};

export const updateRoundRobinDataApi = async (data: ConfigInfo) => {
  const response = await axiosSetup.patch(
    "/roundRobin/updateRoundRobinData",
    data
  );
  return response?.data;
};

export const startCronJobApi = async () => {
  const response = await axiosSetup.post("/roundRobin/shootRoundRobinMessages");
  return response?.data;
};

export const stopCronJobApi = async () => {
  const response = await axiosSetup.post("/roundRobin/stopCronJob");
  return response?.data;
};

export const storeRoundRobinDataApi = async (roundRobinData: ConfigInfo) => {
  const response = await axiosSetup.post(
    "/roundRobin/storeRoundRobinData",
    roundRobinData
  );
  return response?.data;
};

export const pauseCronJobApi = async () => {
  const response = await axiosSetup.post("/roundRobin/pause");
  return response?.data;
};

export const resumeCronJobApi = async () => {
  const response = await axiosSetup.post("/roundRobin/resume");
  return response?.data;
};

export const clearRoundRobinHeaderFooterBodyApi = async () => {
  const response = await axiosSetup.patch("/roundRobin/deleteContent");
  return response?.data;
};
